<template>
    <v-app-bar
            app
            bottom
            class="mobile-menu"
            height="70"
    >
        <v-bottom-navigation
                color="primary"
                grow
                height="70"
        >
            <v-btn
                    v-for="(item, key) in getItems"
                    :key="key"
                    :to="item.to"
                    :class="{
                        'v-btn--active': item.active
                    }"
                    elevation="0"
            >
                <span>{{ $t(item.text) }}</span>
                <v-icon>{{ item.icon }}</v-icon>
                <badge-count
                        v-if="item.to.name === 'other'"
                        :count="$store.state.chat.unreadMessages"
                ></badge-count>
            </v-btn>
        </v-bottom-navigation>
    </v-app-bar>
</template>

<script>
    import BadgeCount from "../ui/BadgeCount";

    export default {
        components: {BadgeCount},
        props: {
            items: {type: Array, default: () => []}
        },
        computed: {
            getItems() {
                return this.items.filter(v => v.mobile);
            }
        }
    }
</script>

<style lang="scss">
    @import 'src/assets/scss/vars';

    .mobile-menu {
        .v-btn {
            min-width: 50px !important;
            padding: 0 6px !important;
            font-weight: 400;
            letter-spacing: normal;
        }
        .v-btn--active {
            background: $colorPrimaryLight !important;
        }
        .v-toolbar__content {
            padding: 0;
        }
    }
</style>